/**
 * The feature flag store handles variables that are stored in the .env file.
 * These variables must be prefixed with 'REACT_APP_FEATURE' and be followed by
 * the index they should be called (e.g. 'REACT_APP_FEATURE_SHOW_PRODUCT').
 * Thus, the suffix needs to be unique. Components that listen to that flag
 * will request the value using the suffix ('SHOW_PRODUCT' i.e.) and based
 * on it being 0 or 1 render accordingly.
 * The variabled 'REACT_APP_INCLUDE_DEV' toggles wether or not feature flags
 * should be included when the app is running on dev. This is 0 by default.
 * If 0, all feature flags will be set to 1. Consequently it is advised to
 * write the variables in a way that 0 disables the feature and 1 enables it.
 */

export default class FeatureFlagStore {
  private flags: Map<string, any>

  constructor() {
    this.loadFlags()
  }

  loadFlags() {
    // TODO this is temporary until there is an endpoint
    // to fetch the feature flags
    this.flags = new Map()

    Object.keys(process.env).forEach((e) => {
      if (e.includes('FEATURE')) {
        this.flags.set(
          e.slice(e.indexOf('FEATURE') + 'FEATURE_'.length),
          parseInt(process.env[e], 10)
        )
      }
    })
  }

  /**
   * Check for a specific feature flag
   * @param key key of the feature flag
   */
  check(key: string) {
    return this.flags.get(key)
  }
}



// WEBPACK FOOTER //
// ./src/stores/FeatureFlagStore.ts